
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1wzqe_mn6nz_9",
  "search-field": "awsui_search-field_1wzqe_mn6nz_41",
  "input-wrapper": "awsui_input-wrapper_1wzqe_mn6nz_48",
  "add-token": "awsui_add-token_1wzqe_mn6nz_55",
  "tokens": "awsui_tokens_1wzqe_mn6nz_62",
  "token-operator": "awsui_token-operator_1wzqe_mn6nz_67",
  "property-editor": "awsui_property-editor_1wzqe_mn6nz_71",
  "property-editor-header": "awsui_property-editor-header_1wzqe_mn6nz_74",
  "property-editor-header-enum": "awsui_property-editor-header-enum_1wzqe_mn6nz_87",
  "property-editor-form": "awsui_property-editor-form_1wzqe_mn6nz_102",
  "property-editor-cancel": "awsui_property-editor-cancel_1wzqe_mn6nz_107",
  "property-editor-actions": "awsui_property-editor-actions_1wzqe_mn6nz_110",
  "property-editor-enum": "awsui_property-editor-enum_1wzqe_mn6nz_118",
  "token-editor": "awsui_token-editor_1wzqe_mn6nz_123",
  "token-editor-form": "awsui_token-editor-form_1wzqe_mn6nz_130",
  "token-editor-field-property": "awsui_token-editor-field-property_1wzqe_mn6nz_133",
  "token-editor-field-operator": "awsui_token-editor-field-operator_1wzqe_mn6nz_136",
  "token-editor-field-value": "awsui_token-editor-field-value_1wzqe_mn6nz_139",
  "token-editor-multiselect-wrapper": "awsui_token-editor-multiselect-wrapper_1wzqe_mn6nz_142",
  "token-editor-multiselect-wrapper-inner": "awsui_token-editor-multiselect-wrapper-inner_1wzqe_mn6nz_147",
  "token-editor-cancel": "awsui_token-editor-cancel_1wzqe_mn6nz_151",
  "token-editor-submit": "awsui_token-editor-submit_1wzqe_mn6nz_154",
  "token-editor-actions": "awsui_token-editor-actions_1wzqe_mn6nz_157",
  "token-editor-grid": "awsui_token-editor-grid_1wzqe_mn6nz_166",
  "token-editor-grid-group": "awsui_token-editor-grid-group_1wzqe_mn6nz_200",
  "token-editor-narrow": "awsui_token-editor-narrow_1wzqe_mn6nz_203",
  "token-editor-supports-groups": "awsui_token-editor-supports-groups_1wzqe_mn6nz_212",
  "token-editor-grid-header": "awsui_token-editor-grid-header_1wzqe_mn6nz_216",
  "token-editor-grid-cell": "awsui_token-editor-grid-cell_1wzqe_mn6nz_222",
  "token-editor-add-token": "awsui_token-editor-add-token_1wzqe_mn6nz_231",
  "custom-content-wrapper": "awsui_custom-content-wrapper_1wzqe_mn6nz_235",
  "custom-control": "awsui_custom-control_1wzqe_mn6nz_239",
  "input": "awsui_input_1wzqe_mn6nz_48",
  "results": "awsui_results_1wzqe_mn6nz_247",
  "token-trigger": "awsui_token-trigger_1wzqe_mn6nz_252",
  "remove-all": "awsui_remove-all_1wzqe_mn6nz_257",
  "join-operation": "awsui_join-operation_1wzqe_mn6nz_258",
  "custom-filter-actions": "awsui_custom-filter-actions_1wzqe_mn6nz_259",
  "constraint": "awsui_constraint_1wzqe_mn6nz_263"
};
  